import script from "./assessClue.vue?vue&type=script&setup=true&lang=js"
export * from "./assessClue.vue?vue&type=script&setup=true&lang=js"

import "./assessClue.vue?vue&type=style&index=0&id=5a4e76d6&scoped=true&lang=css"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4e76d6"]])

export default __exports__